import GjwStatusCell from './src/GjwStatusCell.vue'

GjwStatusCell.install = function(Vue) {
  Vue.component(GjwStatusCell.name, GjwStatusCell)
}

export default GjwStatusCell
